
export const AUTHENTICATION_TYPES = {
	DIRECT: 1,
	CONFIRM_VALUE: 2,
	PROVE_EMAIL: 3,
	PROVIDE_EMAIL: 4,
	PROVIDE_AND_PROVE_EMAIL: 5
}
